var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){return _vm.emitClick()}}},[_c('span',{staticClass:"btn-text"},[_vm._v("Download")])])}
var staticRenderFns = []

export { render, staticRenderFns }